import Faq from '@/models/Faq'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    faqDetails: null
  },

  mutations: {
    setFaqList(state, faqs) {
      each(faqs, faq => {
        const exist = find(state.list, { id: faq.id })
        if (!exist) {
          state.list.push(new Faq(faq))
        }
      })
    },

    clearFaqList(state) {
      state.list = []
    },

    setFaqListMeta(state, meta) {
      state.listMeta = meta
    },

    setFaqDetails(state, faq) {
      if (faq instanceof Faq) {
        state.faqDetails = faq
      } else {
        state.faqDetails = new Faq(faq)
      }
    },

    clearFaqDetails(state) {
      state.faqDetails = null
    }
  },

  actions: {
    async getFaqs({ commit }, params) {
      const query = Faq.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()

      commit('setFaqList', res.data)
      commit('setFaqListMeta', res.meta)
    },

    async getFaqDetails({ commit }, id) {
      const { data } = await Api.get(`faqs/${id}`)
      commit('setFaqDetails', data.data)
    },

    async createFaq({ commit }, formData) {
      return Api.post(`faqs`, formData)
    },

    async updateFaq({ commit }, formData) {
      const { data } = await Api.patch(`faqs/${formData.id}`, formData)
      commit('setFaqDetails', data.data)
    },

    async deleteFaq({ commit, state }, formData) {
      return Api.delete(`faqs/${formData.id}`)
    }
  }
}
